import React from 'react';
import { getTranslation } from '../../../../../utils/translation';
import styles from './ClosedBetLine.module.scss';

const ClosedBetLine = ({ bet }) => {
    return bet.closed ? (
        <div className={styles.closedBetLine}>
            <span className={styles.closedBadge}>{getTranslation('betSlip.betLine.closed')}</span>
        </div>
    ) : null;
};

export default ClosedBetLine;
